import { Fragment, FunctionComponent, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import "./ChatBotPage.scss";

import { useTranslation } from "react-i18next";

import { Suggestions } from "../../components/Shared";
import { translationKeys } from "../../models/app-translation-keys";
import { useChatService } from "../../services/ServiceHooks";
import { useStore } from "../../stores/StoreContext";
import { ActiveThread, ChatPrompt } from "./TempChatSegments";
import { ExchangeErrorsComponent } from "./TempExchangeErrors/ExchangeErrors";

const RawChatBotPage: FunctionComponent = () => {
  const { t } = useTranslation();
  const [showActiveThreadContent, setShowActiveThreadContent] = useState(false);
  const { threadStore } = useStore();
  const chatbotService = useChatService();

  useEffect(() => {
    const showContent = !!threadStore.activeThread?.exchanges?.length || !!threadStore.activeThread?.pendingPrompt;
    setShowActiveThreadContent(showContent);
  }, [
    threadStore.activeThread?.exchanges?.length,
    threadStore.activeThread?.id,
    threadStore.activeThread?.pendingPrompt,
  ]);

  const sendIntroAndDetails = async (suggestion: string) => {
    const requestThread = threadStore.activeThread;
    await chatbotService.sendChatMessage(requestThread, suggestion);
  };

  return (
    <div className="chat-component">
      {!!showActiveThreadContent && <ActiveThread />}

      {!!showActiveThreadContent && !!threadStore.hasThreadErrors && (
        <div className="exchange-errors-container">
          <ExchangeErrorsComponent />
        </div>
      )}

      <div className="prompt-container">
        {!showActiveThreadContent && (
          <Fragment>
            <Suggestions
              suggestionCount={4}
              suggestionsTranslationArray={translationKeys.newThread.suggestions}
              selectSuggestion={sendIntroAndDetails}
            />

            <div className="new-thread-question">
              {t(translationKeys.newThread.greeting, { chatBotName: t(translationKeys.aiNameAbbreviation) })}
            </div>
          </Fragment>
        )}

        <ChatPrompt />
      </div>
    </div>
  );
};

export const ChatBotPage = observer(RawChatBotPage);
